export const defaultMetaphoricCardsCards = [
    {
        "id": 1,
        "name": "Світи",
        "name_ua": "Світи",
        "name_en": "The Worlds",
        "number_of_cards": 60,
        "title_card_img": "https://leelaonline-metaphoric-cards.s3.eu-north-1.amazonaws.com/1/0.jpg",
        "card_img_url_prefix": "https://leelaonline-metaphoric-cards.s3.eu-north-1.amazonaws.com/1/",
        "card_img_url_extension": ".jpg",
        "author_name": "Юлія Люліна & Валерія Федь",
        "author_name_ua": "Юлія Люліна & Валерія Федь",
        "author_name_en": "Julia Liulina & Valeria Fed",
        "author_link": "https://svity.wayforpay.shop",
    },
    {
        "id": 5,
        "name": "Дзеркало душі",
        "name_ua": "Дзеркало душі",
        "name_en": "Soul mirror",
        "number_of_cards": 50,
        "title_card_img": "https://leelaonline-metaphoric-cards.s3.eu-north-1.amazonaws.com/5/0.jpg",
        "card_img_url_prefix": "https://leelaonline-metaphoric-cards.s3.eu-north-1.amazonaws.com/5/",
        "card_img_url_extension": ".jpg",
        "author_name": "Наталія Колодченко",
        "author_name_ua": "Наталія Колодченко",
        "author_name_en": "Natalia Kolodchenko",
        "author_link": "https://www.instagram.com/kolodchenko.nataliia/",
    },
    {
        "id": 3,
        "name": "Подих",
        "name_ua": "Подих",
        "name_en": "Breath",
        "number_of_cards": 58,
        "title_card_img": "https://leelaonline-metaphoric-cards.s3.eu-north-1.amazonaws.com/3/0.jpg",
        "card_img_url_prefix": "https://leelaonline-metaphoric-cards.s3.eu-north-1.amazonaws.com/3/",
        "card_img_url_extension": ".jpg",
        "author_name": "Юлія Софілканич",
        "author_name_ua": "Юлія Софілканич",
        "author_name_en": "Yulia Sofilkanich",
        "author_link": "https://www.instagram.com/jul.psycards/",
    },
    {
        "id": 6,
        "name": "Надихайся",
        "name_ua": "Надихайся",
        "name_en": "Be inspired",
        "number_of_cards": 30,
        "title_card_img": "https://leelaonline-metaphoric-cards.s3.eu-north-1.amazonaws.com/6/0.jpg",
        "card_img_url_prefix": "https://leelaonline-metaphoric-cards.s3.eu-north-1.amazonaws.com/6/",
        "card_img_url_extension": ".jpg",
        "author_name": "Іра Рей",
        "author_name_ua": "Іра Рей",
        "author_name_en": "Ira Ray",
        "author_link": "https://www.instagram.com/iraray_ray/",
    },
    {
        "id": 7,
        "name": "Послання від архетипів «Лея»",
        "name_ua": "Послання від архетипів «Лея»",
        "name_en": "Archetype messages «Lea»",
        "number_of_cards": 48,
        "title_card_img": "https://leelaonline-metaphoric-cards.s3.eu-north-1.amazonaws.com/7/0.jpg",
        "card_img_url_prefix": "https://leelaonline-metaphoric-cards.s3.eu-north-1.amazonaws.com/7/",
        "card_img_url_extension": ".jpg",
        "author_name": "Юля Ратушна",
        "author_name_ua": "Юля Ратушна",
        "author_name_en": "Yulia Ratushna",
        "author_link": "https://www.instagram.com/raatushna/",
    },
    {
        "id": 8,
        "name": "Послання від архетипів «Сенси»",
        "name_ua": "Послання від архетипів «Сенси»",
        "name_en": "Archetype messages «Senses»",
        "number_of_cards": 44,
        "title_card_img": "https://leelaonline-metaphoric-cards.s3.eu-north-1.amazonaws.com/8/0.jpg",
        "card_img_url_prefix": "https://leelaonline-metaphoric-cards.s3.eu-north-1.amazonaws.com/8/",
        "card_img_url_extension": ".jpg",
        "author_name": "Юля Ратушна",
        "author_name_ua": "Юля Ратушна",
        "author_name_en": "Yulia Ratushna",
        "author_link": "https://www.instagram.com/raatushna/",
    },
    {
        "id": 9,
        "name": "Послання з Всесвіту",
        "name_ua": "Послання з Всесвіту",
        "name_en": "Messages from the Universe",
        "number_of_cards": 41,
        "title_card_img": "https://leelaonline-metaphoric-cards.s3.eu-north-1.amazonaws.com/9/0.jpeg",
        "card_img_url_prefix": "https://leelaonline-metaphoric-cards.s3.eu-north-1.amazonaws.com/9/",
        "card_img_url_extension": ".jpeg",
        "author_name": "Наталія Колодченко",
        "author_name_ua": "Наталія Колодченко",
        "author_name_en": "Natalia Kolodchenko",
        "author_link": "https://www.instagram.com/kolodchenko.nataliia/",
    },
]

export const metaphoricCardAuthors = {
    1: {
        name: "Юлія Люліна & Валерія Федь",
        name_en: "Julia Liulina & Valeria Fed",
        link: "https://svity.wayforpay.shop"
    },
    2: {
        name: "Наталія Колодченко",
        name_en: "Natalia Kolodchenko",
        link: "https://www.instagram.com/kolodchenko.nataliia/"
    },
    5: {
        name: "Наталія Колодченко",
        name_en: "Natalia Kolodchenko",
        link: "https://www.instagram.com/kolodchenko.nataliia/"
    },
    3: {
        name: "Юлія Софілканич",
        name_en: "Yulia Sofilkanich",
        link: "https://www.instagram.com/jul.psycards/"
    },
    4: {
        name: "Наталія Марченко",
        name_en: "Natalia Marchenko",
        link: "https://www.instagram.com/madam.brainstorm/"
    },
    6: {
        name: "Іра Рей",
        name_en: "Ira Ray",
        link: "https://www.instagram.com/iraray_ray/"
    },
    7: {
        name: "Юля Ратушна",
        name_en: "Yulia Ratushna",
        link: "https://www.instagram.com/raatushna/"
    },
    8: {
        name: "Юля Ратушна",
        name_en: "Yulia Ratushna",
        link: "https://www.instagram.com/raatushna/"
    },
    9: {
        name: "Наталія Колодченко",
        name_en: "Natalia Kolodchenko",
        link: "https://www.instagram.com/kolodchenko.nataliia/"
    },

}